// * Migrated
import { useState } from 'react';
import { INotification } from '../components/UI/Notifications/NotificationToast';

export const useNotifications = (defaultNotifications?: INotification[]) => {
  const [notifications, setNotifications] = useState<INotification[]>(defaultNotifications ?? []);

  const addNotification = (notification: INotification) => {
    setNotifications((prevState) => {
      return [...prevState, notification];
    });
  };

  const removeNotification = (id: number) => {
    setNotifications((prevState) => {
      return prevState.filter((notification) => notification.id !== id);
    });
  };

  return { notifications, addNotification, removeNotification };
};
